import pick from 'lodash/pick';

export function formatSourceElement(data) {
  return {
    ...data,
    scaleX: data.scaleX || 1,
    scaleY: data.scaleY || 1,
    type: data.type || 'image',
  };
}

export const pickResultFromElement = (element) => {
  return pick(element, [
    'id',
    'innerImageId',
    'innerTaskId',
    'width',
    'height',
    'url',
    'data',
    'illegal',
    'unitId',
    'type',
    'flowId',
    'scaleX',
    'scaleY',
  ]);
};
